type QueryParamValue = string | number;
type Input = Record<
  string,
  null | undefined | QueryParamValue | QueryParamValue[]
>;

export const stringify = (obj: Input) => {
  const queryParamsFlat: Record<string, QueryParamValue>[] = [];

  Object.entries(obj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((value) => {
        queryParamsFlat.push({
          key,
          value,
        });
      });
      return;
    }

    queryParamsFlat.push({
      key,
      value,
    });
  });

  return queryParamsFlat
    .map(({ key, value }, i) => {
      const separator = i === 0 ? "?" : "&";

      return `${separator}${key}=${value}`;
    })
    .join("");
};
